import ability, { Can } from "../../../../../casl/Can";
import { AppAvatar, AppBox, AppIconButton, AppLink, AppPaper, AppTitle } from "../../../../../commons/components";
import IconBin from "../../../../../commons/components/icons/bin";
import IconEdit from "../../../../../commons/components/icons/edit";
import { RolePolicyActionEnum } from "../../../../../commons/enums/role-policy-action.enum";
import { ManageFootballCompetition } from "../../../../../commons/models/football/admin/manage-football-competition";
import { ManageFootballHostedCompetition } from "../../../../../commons/models/football/admin/manage-football-hosted-competition";
import { ManageFootballTeam } from "../../../../../commons/models/football/admin/manage-football-team";
import { toTitleCase } from "../../../../../commons/utilities/string-utils";

const HostedTournamentCard = ({
  teamInfo,
  hostedTournamentInfo,
  onEdit,
  onDelete,
}: {
  teamInfo: ManageFootballTeam;
  hostedTournamentInfo: ManageFootballHostedCompetition;
  onEdit: () => void;
  onDelete: () => void;
}) => {
  const canReadSubTeam = ability.can(
    RolePolicyActionEnum.READ,
    new ManageFootballTeam(teamInfo) || new ManageFootballCompetition(hostedTournamentInfo)
  );
  const subteamPath = `/manage/teams/${teamInfo.id}/hosted-tournaments/${hostedTournamentInfo.id}`;

  const handleLinkClick = (e: MouseEvent) => {
    if (!canReadSubTeam) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      window.scrollTo(0, 0);
    }
  };

  return (
    <AppPaper padding="xs" shadow="xs">
      <AppBox justifyContent="space-between" alignItems="center">
        <AppLink onClick={handleLinkClick} style={{ pointerEvents: canReadSubTeam ? "auto" : "none" }} to={subteamPath}>
          <AppBox gap="xs" alignItems="center">
            <AppAvatar username={hostedTournamentInfo?.title || ""} src={hostedTournamentInfo?.logo || ""} size="lg" />
            <AppBox flexDirection="column">
              <AppBox alignItems="center" gap="2xs">
                <AppTitle as="h6">{toTitleCase(hostedTournamentInfo?.title)}</AppTitle>
              </AppBox>
            </AppBox>
          </AppBox>
        </AppLink>
        <AppBox gap="xs" justifyContent="end" alignItems="center">
          <Can
            I={RolePolicyActionEnum.UPDATE}
            this={new ManageFootballTeam(teamInfo) || new ManageFootballCompetition(hostedTournamentInfo)}
          >
            <AppIconButton
              variant="light"
              onClick={() => {
                onEdit();
              }}
              icon={<IconEdit />}
            />
          </Can>
          <Can I={RolePolicyActionEnum.UPDATE} this={new ManageFootballTeam(teamInfo)}>
            <AppIconButton
              variant="light"
              color="danger"
              onClick={() => {
                onDelete();
              }}
              icon={<IconBin />}
            />
          </Can>
        </AppBox>
      </AppBox>
    </AppPaper>
  );
};

export default HostedTournamentCard;
